import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'
import { applyUpdate, onUpdateAvailable } from '../lib/pwa'

export function UpdatePrompt() {
  const [available, setAvailable] = useState(false)

  useEffect(() => onUpdateAvailable(() => setAvailable(true)), [])

  if (!available) return null
  return (
    <div
      role="status"
      className="fixed inset-x-3 bottom-24 z-40 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-ink px-4 py-3 text-white shadow-lift sm:bottom-6"
    >
      <RefreshCw aria-hidden="true" className="h-4 w-4" />
      <p className="flex-1 text-[14px]">Dostupna je nova verzija Računka.</p>
      <button type="button" className="btn rounded-full bg-white px-4 text-ink" onClick={applyUpdate}>
        Osvježi
      </button>
    </div>
  )
}
